/**
 * @shelf-version: 2.0.0
 */

import InView from './in-view'

export default InView
